import { CancelBig, Menu } from '@app/components/various/Icons';
import { useTranslation } from 'react-i18next';

interface Props {
  isMenuOpened: boolean;
  onClick: () => void;
}

export const MenuToggle = ({ isMenuOpened, onClick }: Props) => {
  const { t } = useTranslation(['menu']);

  return (
    <button
      type="button"
      className="relative size-8 rounded-full after:absolute after:-inset-2"
      aria-expanded={isMenuOpened}
      onClick={onClick}
      aria-label={t('menu:open_main_menu')}
    >
      {isMenuOpened ?
        <CancelBig className="size-8" />
      : <Menu className="size-8" />}
    </button>
  );
};
